import {authToken} from '@/utils/helpers'
export default function auth({ next }) {
  if (!authToken()) {
    return next({ name: 'login.index' });
  }

  return next();
}